<template>
  <div class="resetpass-page header-wrapper animate fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">

          <div class="block-border radius block">
            <form class="" @submit.prevent="submit" novalidate>
              <h3 class="mb-15">ตั้งรหัสผ่านใหม่</h3>
              <div class="">
                <label class="form__label" for="password1">รหัสผ่าน</label>
                <input class="form__text" type="password" id="password1" v-model="info.password1" :class="{ 'form__input--error': $v.isError('password1') }" />
                <div class="alert alert--error" v-show="$v.$errors.password1.empty">กรุณากรอกรหัสผ่าน</div>
                <div class="alert alert--error" v-show="$v.$errors.password1.minLength">รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร</div>
                <div class="alert alert--error" v-show="$v.$errors.password1.tooEasy">กรุณาใช้รหัสผ่านที่เดายากกว่านี้</div>
              </div>
              <div class="">
                <label class="form__label" for="password2">ยืนยันรหัสผ่าน</label>
                <input class="form__text" type="password" id="password2" v-model="info.password2" :class="{ 'form__input--error': $v.isError('password2') }" />
                <div class="alert alert--error" v-show="$v.$errors.password2.empty">กรุณากรอกรหัสผ่าน</div>
                <div class="alert alert--error" v-show="!$v.$errors.password2.empty && $v.$errors.password2.unmatched">กรุณากรอกรหัสผ่านให้ตรงกัน</div>
              </div>
              <button class="btn btn--purple btn--full" :disabled="submitting">เปลี่ยนรหัสผ่าน</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EditPassword',
  data () {
    return {
      submitting: false,
      email: '',
      info: {
        password1: '',
        password2: ''
      },
      $v: null
    }
  },
  created () {
    if (!this.$route.query.email || !this.$route.query.token) {
      this.$router.push('/')
    }

    this.email = this.$route.query.email
    this.token = this.$route.query.token

    this.$store.dispatch('initUser').then(() => {
      if (this.$store.state.user) {
        this.$router.push('/')
      }
    })

    this.$v = this.$validator.init(this.info, {
      password1: {
        checkEmpty: true,
        minLength: 6,
        checkPassword: true
      },
      password2: {
        checkEmpty: true,
        checkMatch: 'password1'
      }
    })
  },
  methods: {
    submit (event) {
      if (!this.$v.validate()) {
        this.$forceUpdate()
        this.$utils.scrollToFirstErrors()
        return
      }

      if (this.submitting) {
        return
      }
      this.submitting = true

      this.$modal.show({
        title: 'กำลังส่งข้อมูล',
        text: 'กรุณารอสักครู่',
        okButton: false
      })

      const payload = {
        email: this.email,
        token: this.token,
        password: this.info.password1
      }

      this.$http.post('members/resetPassword', payload)
        .then(resp => {
          this.submitting = false
          this.$router.push('/user/login')
          this.$modal.show({
            title: 'ระบบได้ทำการรีเซ็ตรหัสผ่านใหม่แล้ว',
            text: 'กรุณาทำการล็อกอินเข้าสู่ระบบด้วยรหัสผ่านใหม่'
          })
        })
        .catch(err => {
          console.log(err)
          this.submitting = false
          this.$modal.show({
            title: 'ผิดพลาด',
            text: 'ลิงก์ของคุณไม่ถูกต้อง หรืออาจจะหมดอายุ กรุณาขอรีเซ็ตรหัสผ่านใหม่อีกครั้ง'
          })
        })
    }
  }
}
</script>

<style scoped>

.resetpass-page .container {
  background: transparent;
}

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?285dc43c